import { render, staticRenderFns } from "./ieltsmentor_collapse_dieu_khoan_dang_ky_hoc.vue?vue&type=template&id=fff04104&scoped=true"
import script from "./ieltsmentor_collapse_dieu_khoan_dang_ky_hoc.vue?vue&type=script&lang=js"
export * from "./ieltsmentor_collapse_dieu_khoan_dang_ky_hoc.vue?vue&type=script&lang=js"
import style0 from "./ieltsmentor_collapse_dieu_khoan_dang_ky_hoc.vue?vue&type=style&index=0&id=fff04104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff04104",
  null
  
)

export default component.exports